export const printTable = {
  methods: {
    CustomStyle(bgColor = "#0D142B", Txtcolor = "black") {
      return `
      .cellFont {
        font: 12pt Calibri,Roboto,"Comic Sans", Tahoma, Times, Georgia;
        color: 'red'
      }
    .myContainer {
      
      display: flex;
      flex-direction: column;
      padding: 10px 15px;
      background-color: white;
    }
    .printHeader {
      font-weight: bold
      background-color: ${bgColor};
      border-radius: 20px 20px 0 0;
      border-bottom: 3px solid black;
      flex-wrap: wrap;
      font-size: 2rem;
      color: ${Txtcolor};
      padding: 15px 10px;
      display: flex;
      flex-direction: row;
      justify-content: center;
    }
    
   
    .my-table-content {
      border-collapse: collapse;
      background-color: white;
    
    }
   
    
    #my-table-Header {
     
     
    }
    .my-table-Header {
      color: ${Txtcolor};
      text-align: center;
      font-weight: bold;
    }
    thead > tr > th {
      border-bottom: gray solid 1px;
      border-right: gray solid 1px;
      background-color: ${bgColor};
      padding: 7px 15px;
     
    }
   
    .my-table-content > tbody > tr > td {
      padding: 7px;
      font-size: 14px;
      color: black;
    
      border-left: lightgrey solid 1px;
      border-right: lightgrey solid 1px;
      border-bottom: lightgrey solid 1px;
    }
    
    
    #myFooter {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      border-bottom: 5px double;
      border-top: 4px solid brown;
      padding: 4px 8px;
      margin-top: 1.5rem
      
    }
    #myFooter> .totalPrice {
      margin-left: 1.5rem;
      font-weight: bold;
      font-size: 1rem;
      
    }
    `;
    },
    CreateText: element => txt => {
      const myElement = document.createElement(element);
      const textNode = document.createTextNode(txt);
      myElement.appendChild(textNode);
      return myElement;
    },
    PageHeader(title) {
      if (!title) title = `${this.Title.toUpperCase()} INVOICE`;
      const header = document.createElement("caption");
      const pageHeader = document.createElement("div");
      pageHeader.className = "printHearder";
      pageHeader.appendChild(this.CreateText("div")(title));
      header.appendChild(pageHeader);
      // console.log(header);
      return header;
    },
    PrintReport(items = [], headers = [], title) {
      const container = document.createElement("div");
      container.className = "myContainer";
      container.appendChild(
        this.CreateTableBody(items.reverse(), headers, title)
      );
      // container.appendChild(tableTest);
      container.appendChild(this.CreateTableFooter());
      // const clear = document.createElement("div");
      // clear.id = "clearFix";
      // container.appendChild(clear);
      return container;
    },
    appendParent() {
      let page = document.getElementById("printContent");
      const first = page.firstChild;
      while (page.lastChild) {
        page.removeChild(page.lastChild);
      }
      page.appendChild(first);
      page.appendChild(this.PrintReport());
      // console.log(page);
    },

    CreateTableHeader(customHeader = []) {
      const headFrg = document.createDocumentFragment();
      const thead = document.createElement("thead");
      thead.id = "my-table-Header";
      const tr = document.createElement("tr");
      customHeader.forEach(({ text }) => {
        let th = this.CreateText("th")(text);
        th.className = "my-table-Header";
        headFrg.appendChild(th);
      });
      tr.appendChild(headFrg);
      thead.appendChild(tr);
      return thead;
    },
    CreateBodyRow(row, header = []) {
      let rowFrg = document.createDocumentFragment();
      header.forEach(({ text, value, width, type }) => {
        let Amount = Math.abs(row.Amount).toLocaleString();
        // console.log(Amount);
        let content = row[value] || "";
        // console.log(row);

        // console.log(typeof content);
        if (typeof content === "number") content = content.toLocaleString();

        if (
          text === row.Acc ||
          ((text.toUpperCase() === "DEPOSIT" || text.toUpperCase() == "IN") &&
            row.Acc == "Dr") ||
          ((text.toUpperCase() === "WITHDRAWAL" ||
            text.toUpperCase() == "OUT") &&
            row.Acc == "Cr")
        )
          content = `${Amount} ${row.AmountType || ""}`;
        if (text.toUpperCase() === "BALANCE" && typeof content === "number") {
          // console.log(content);
          content += ` ${row.AmountType || ""}`;
        }

        let td = this.CreateText("td")(content);
        if (type && type.toUpperCase() === "HTML") {
          td.textContent = "";
          // console.log(content);
          td.className = "cellFont";
          td.appendChild(content);
        }
        // if (text.toUpperCase() == "DATE") td.width = "100px";
        td.width = width || null;
        // console.log(td);

        rowFrg.appendChild(td);
      });
      let tableRow = document.createElement("tr");
      tableRow.appendChild(rowFrg);
      return tableRow;
    },
    CreateTableBody(items = [], header = [], title) {
      const page1 = document.createElement("tbody");
      // const page2 = document.createElement("tbody");

      items.forEach((row, index) => {
        row["index"] = index + 1;
        page1.appendChild(this.CreateBodyRow(row, header));
        // if (row.index < 23) page1.appendChild(this.CreateBodyRow(row, header));
        // else page2.appendChild(this.CreateBodyRow(row, header));
      });

      // console.log(tbody);
      const firstPage = document.createElement("table");
      firstPage.id = "my-table";
      firstPage.className = "my-table-content";
      firstPage.appendChild(this.PageHeader(title));
      firstPage.appendChild(this.CreateTableHeader(header));
      firstPage.appendChild(page1);

      const printFrg = document.createDocumentFragment();
      printFrg.appendChild(firstPage);
      // if (items.length > 20) printFrg.appendChild(othePage);

      return printFrg;
    },

    CreateTableFooter() {
      const FooterDiv = document.createElement("tr");
      FooterDiv.id = "myFooter";
      const footerData = this.AvailibleBalanceArray || [];
      footerData.forEach(Total => {
        let { Amount, AmountType } = Total || {
          Amount: null,
          AmountType: null,
        };
        let text = `${Amount && Amount.toLocaleString()} ${AmountType || ""} `;
        const footerContent = this.CreateText("td")(text);
        footerContent.className = "totalPrice";
        // console.log(footerContent);
        FooterDiv.appendChild(footerContent);
      });
      const Div = document.createElement("div");
      // Div.id = "myFooter";
      Div.appendChild(FooterDiv);
      return Div;
    },
  },
};
